import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { Avatar } from '@infl-ts/ui-advocate-components';
import { useToggle } from '@infl-ts/util-hooks';
import { Alert, Box, Button, Card, Collapse, styled, Typography } from '@mui/material';
import { absurd } from 'fp-ts/function';
import { Trans, useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var getTitle = function getTitle(status, t, stage) {
  switch (status) {
    case 'ActivityTimelineCorporateConfirmation':
      return stage ? t("You've been progressed to Stage {{stageNumber}}", {
        stageNumber: stage + 1
      }) : t('Your challenge submission has been approved');

    case 'ActivityTimelineCorporateRedo':
      return t("You've been sent back to Stage {{stageNumber}} to try again", {
        stageNumber: stage ? stage + 1 : 1
      });

    case 'ActivityTimelineChallengeRejected':
      return t('This challenge submission was declined');

    default:
      absurd(status);
  }
};

var getSeverity = function getSeverity(status) {
  switch (status) {
    case 'ActivityTimelineCorporateConfirmation':
      return 'success';

    case 'ActivityTimelineCorporateRedo':
      return 'warning';

    case 'ActivityTimelineChallengeRejected':
      return 'error';

    default:
      absurd(status);
  }
};

var ResizableCard = styled(Card)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", ";\n"])), function (p) {
  return p.theme.spacing(2);
});

var CorporateConfirmationAlert = function CorporateConfirmationAlert(_ref) {
  var status = _ref.status,
      feedback = _ref.feedback,
      stage = _ref.stage,
      admin = _ref.admin;

  var _useToggle = useToggle(true),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      feedbackExpanded = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      expandFeedback = _useToggle2$.on,
      collapseFeedback = _useToggle2$.off;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      mb: 3,
      width: 1,
      height: 'fit-content'
    },
    component: feedback ? ResizableCard : 'div',
    "data-element": "Box",
    "data-component": "CorporateConfirmationAlert",
    "data-source-file": "index.tsx",
    children: [status !== 'ActivityTimelineReceivedFeedback' ? /*#__PURE__*/_jsx(Alert, {
      severity: getSeverity(status),
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "body2",
        children: getTitle(status, t, stage)
      })
    }) : null, feedback && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Collapse, {
        "in": feedbackExpanded,
        children: [/*#__PURE__*/_jsxs(Box, {
          sx: {
            mt: status !== 'ActivityTimelineReceivedFeedback' ? 2 : 0,
            mb: 2,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          },
          children: [/*#__PURE__*/_jsx(Avatar, {
            member: admin !== null && admin !== void 0 ? admin : {
              id: '0',
              name: 'Admin',
              avatarUrl: null
            },
            disabledPopover: true
          }), /*#__PURE__*/_jsxs(Box, {
            sx: {
              ml: 2,
              my: 0.5,
              display: 'flex',
              flexDirection: 'column'
            },
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "h4",
              children: /*#__PURE__*/_jsx("b", {
                children: t('Admin Feedback')
              })
            }), admin && /*#__PURE__*/_jsx(Typography, {
              variant: "caption",
              children: /*#__PURE__*/_jsx(Trans, {
                values: {
                  adminName: admin.name
                },
                components: {
                  bold: /*#__PURE__*/_jsx("b", {})
                },
                children: 'From <bold>{{adminName}}</bold>'
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            mt: 2,
            color: function color(t) {
              return t.palette.text.secondary;
            }
          },
          children: /*#__PURE__*/_jsx("q", {
            children: feedback
          })
        })]
      }), /*#__PURE__*/_jsx(Button, {
        sx: {
          mt: status !== 'ActivityTimelineReceivedFeedback' ? 2 : 0,
          width: '100%'
        },
        variant: "text",
        size: "small",
        onClick: feedbackExpanded ? collapseFeedback : expandFeedback,
        children: feedbackExpanded ? t('Hide feedback') : t('Show feedback')
      })]
    })]
  });
};

export default CorporateConfirmationAlert;